import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';

import { useTranslation } from 'react-i18next';

// style
// import styles from '../../dam/legend/style';

// const useStyles = makeStyles(styles);

export default function DamLargeLegendRRI() {
  const { t } = useTranslation();
  // const classes = useStyles();

  function Row() {
    return (
      <>
        <div style={{
          width: 280,
          borderRadius: 8,
          padding: 16,
          gap: 16,
          background: '#FFFFFFCC',
          boxShadow: '0px 8px 24px 0px #08213615',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}>
          <Grid item xs>
            <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 8 }}>
              <Box>
                <Box style={{ fontFamily: 'Sarabun', fontWeight: 700, fontSize: 15, lineHeight: '100%', color: '#1C1C1E' }}>
                  {t('ปริมาณกักเก็บ (%)')}
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid item xs>
            <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 8 }}>
              <Box style={{ width: 28, height: 28, backgroundColor: '#C70000', flexShrink: 0 }} />
              <Box>
                <Box style={{ fontFamily: 'Sarabun', fontWeight: 700, fontSize: 15, lineHeight: '100%', color: '#1C1C1E' }}>
                  {t('ล้นเขื่อน')}<span style={{ fontWeight: 500, fontSize: 13, color: '#C70000', fontFamily: 'Sarabun' }}> &gt; 100%</span>
                </Box>
                <Box style={{ fontFamily: 'Sarabun', fontWeight: 400, fontSize: 11, lineHeight: '120%', color: '#8E8E93' }}>
                  {t('ปริมาณน้ำสูงเกินความจุอ่าง')}
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid item xs>
            <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 8 }}>
              <Box style={{ width: 28, height: 28, backgroundColor: '#ff0000', flexShrink: 0 }} />
              <Box>
                <Box style={{ fontFamily: 'Sarabun', fontWeight: 700, fontSize: 15, lineHeight: '100%', color: '#1C1C1E' }}>
                  {t('มากกว่าเกณฑ์')}<span style={{ fontWeight: 500, fontSize: 13, color: '#ff0000', fontFamily: 'Sarabun' }}> &gt; 80%</span>
                </Box>
                <Box style={{ fontFamily: 'Sarabun', fontWeight: 400, fontSize: 11, lineHeight: '120%', color: '#8E8E93' }}>
                  {t('ปริมาณน้ำสูงกว่าเกณฑ์บน')}
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid item xs>
            <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 8 }}>
              <Box style={{ width: 28, height: 28, backgroundColor: '#003cfa', flexShrink: 0 }} />
              <Box>
                <Box style={{ fontFamily: 'Sarabun', fontWeight: 700, fontSize: 15, lineHeight: '100%', color: '#1C1C1E' }}>
                  {t('ปานกลาง')}<span style={{ fontWeight: 500, fontSize: 13, color: '#003cfa', fontFamily: 'Sarabun' }}> &gt; 50%</span>
                </Box>
                <Box style={{ fontFamily: 'Sarabun', fontWeight: 400, fontSize: 11, lineHeight: '120%', color: '#8E8E93' }}>
                  {t('ปริมาณน้ำอยู่ตามเกณฑ์ควบคุม')}
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid item xs>
            <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 8 }}>
              <Box style={{ width: 28, height: 28, backgroundColor: '#00b050', flexShrink: 0 }} />
              <Box>
                <Box style={{ fontFamily: 'Sarabun', fontWeight: 700, fontSize: 15, lineHeight: '100%', color: '#1C1C1E' }}>
                  {t('น้อย')}<span style={{ fontWeight: 500, fontSize: 13, color: '#00b050', fontFamily: 'Sarabun' }}> &gt; 30%</span>
                </Box>
                <Box style={{ fontFamily: 'Sarabun', fontWeight: 400, fontSize: 11, lineHeight: '120%', color: '#8E8E93' }}>
                  {t('ปริมาณน้ำต่ำกว่าเกณฑ์ล่าง')}
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid item xs>
            <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 8 }}>
              <Box style={{ width: 28, height: 28, backgroundColor: '#ffc000', flexShrink: 0 }} />
              <Box>
                <Box style={{ fontFamily: 'Sarabun', fontWeight: 700, fontSize: 15, lineHeight: '100%', color: '#1C1C1E' }}>
                  {t('น้อยกว่าเกณฑ์')}<span style={{ fontWeight: 500, fontSize: 13, color: '#ffc000', fontFamily: 'Sarabun' }}> &lt;= 30%</span>
                </Box>
                <Box style={{ fontFamily: 'Sarabun', fontWeight: 400, fontSize: 11, lineHeight: '120%', color: '#8E8E93' }}>
                  {t('ปริมาณน้ำต่ำกว่าเกณฑ์ล่าง')}
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid item xs>
            <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 8 }}>
              <Box style={{ width: 28, height: 28, backgroundColor: '#AEAEB2', flexShrink: 0 }} />
              <Box>
                <Box style={{ fontFamily: 'Sarabun', fontWeight: 700, fontSize: 15, lineHeight: '100%', color: '#1C1C1E' }}>
                  {t('ไม่มีข้อมูลรายวัน')}
                </Box>
                <Box style={{ fontFamily: 'Sarabun', fontWeight: 400, fontSize: 11, lineHeight: '120%', color: '#8E8E93' }}>
                  {t('ไม่พบข้อมูลส่งกลับจากสถานี')}
                </Box>
              </Box>
            </Box>
          </Grid>
        </div>
      </>
    );
  }

  return (
    <div>
      <Grid container spacing={0}>
        <Row />
      </Grid>
    </div>
  );
}
